import startCase from 'lodash.startcase';
import trimWhiteSpace from './trimWhiteSpace';

const isEmpty = (value) =>
    value == null || trimWhiteSpace(value) === '' || trimWhiteSpace(value) === 'default';

const buildMessage = (label) =>
    (label ? `${label} field is required!` : 'This field is required!');

// Default redux-form validator. Falls back to startCase(name) for the label
// since redux-form v7 doesn't expose the Field's `label` prop to validators
// (only form-level props via the 3rd arg). Existing call sites keep working
// because the only difference from the original is a per-field name in the
// error string.
const fieldRequired = (value, _allValues, _props, name) => {
    if (!isEmpty(value)) return undefined;
    const fieldName = typeof name === 'string' && name.trim() ? startCase(name) : '';
    return buildMessage(fieldName);
};

// Opt-in factory for forms that want to override the auto-generated label
// (e.g. when the visible label differs from a startCase of the field name).
// Usage:
//     const validateRequired = fieldRequiredWithLabels({
//         subject: 'Subject',
//         description: 'How can we help?',
//     });
//     <Field name="subject" validate={validateRequired} />
// Any field not present in the map falls back to startCase(name); any call
// with no map is equivalent to the default `fieldRequired`.
export const fieldRequiredWithLabels = (labels = {}) =>
    (value, _allValues, _props, name) => {
        if (!isEmpty(value)) return undefined;
        const override = labels[name];
        if (typeof override === 'string' && override.trim()) {
            return buildMessage(override.trim());
        }
        const fallback = typeof name === 'string' && name.trim() ? startCase(name) : '';
        return buildMessage(fallback);
    };

export default fieldRequired;



// WEBPACK FOOTER //
// ./src/client/utils/fieldRequired.js